import { render } from "./btn-multi-states.vue?vue&type=template&id=5dce48de&scoped=true"
import script from "./btn-multi-states.js?vue&type=script&lang=js&external"
export * from "./btn-multi-states.js?vue&type=script&lang=js&external"

import "./btn-multi-states.scss?vue&type=style&index=0&id=5dce48de&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dce48de"]])

export default __exports__